import _ from 'lodash'
import { colors, createMuiTheme, responsiveFontSizes as responsiveFontSizesHelper } from '@material-ui/core'
import { THEMES } from 'src/constants'
import { softShadows } from './shadows'
import typography from './typography'

const baseTheme = {
  direction: 'ltr',
  name: THEMES.LIGHT,
  typography,
  overrides: {
    MuiInputBase: {
      input: {
        '&::placeholder': {
          opacity: 1,
          color: colors.blueGrey[600],
        },
      },
    },
  },
  palette: {
    type: 'light',
    action: {
      active: colors.blueGrey[600],
    },
    background: {
      default: colors.common.white,
      dark: '#f4f6f8',
      paper: colors.common.white,
    },
    primary: {
      main: '#8bc34a',
    },

    secondary: {
      main: '#27ae60',
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600],
    },
  },
  shadows: softShadows,
}

export const createTheme = (config = {}) => {
  const { responsiveFontSizes, fontSize } = config

  let themeConfig = _.merge({}, baseTheme)

  if (fontSize) {
    themeConfig.typography = _.merge({}, themeConfig.typography, { fontSize })
  }

  let theme = createMuiTheme(themeConfig)

  if (responsiveFontSizes) {
    theme = responsiveFontSizesHelper(theme)
  }

  return theme
}
